$(function () {

    var errorHtml = '<div id="consent-error-message"><span class="field-validation-error">You must consent to be contacted.</span></div>';

    $('#register-alert-button').click(function () {
        if (!($('#Consent').is(':checked'))) {
            $('#consent-error-message').remove();

            $('#Consent').closest('.checkbox').after(errorHtml);

            if ($('#MobileNumber').val()) {
                return false;
            } else {
                return true;
            }
        }
    });

    $('#consent-checkbox #Consent').change(function () {
        if ($(this).is(':checked')) {
            $('#consent-error-message').remove();
        } else {
            $(this).closest('.checkbox').after(errorHtml);
        }
    });

});